/**
 * @generated SignedSource<<db4dd10a4e100afc581c7518b1f1eaff>>
 * @relayHash 2da18ddcf067ae3b3f655513eb48acac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type creationSettingsQueryQuery$variables = {
  ownerAri: string;
  tenantId: string;
};
export type creationSettingsQueryQuery$data = {
  readonly settings_creationSettings: {
    readonly autoApply: boolean | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type creationSettingsQueryQuery = {
  response: creationSettingsQueryQuery$data;
  variables: creationSettingsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }
    ],
    "concreteType": "SettingsCreationSettings",
    "kind": "LinkedField",
    "name": "settings_creationSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "autoApply"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "creationSettingsQueryQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "creationSettingsQueryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0",
    "metadata": {},
    "name": "creationSettingsQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d5e237e68920e0355d028a1df4e44e10";

export default node;
